import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from "axios/index";
import {RESOURCES as inventoryResources} from '../fuseInventoryResourceMap';
import {
    Table,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
    TableBody
} from 'material-ui/Table';
import FuseTheme from "../global/theme";
import IconButton from 'material-ui/IconButton';
import IconToggleOpen from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import IconToggleClose from 'material-ui/svg-icons/hardware/keyboard-arrow-up';

/**
 * A component for displaying Audit contents and retrieving Repack/Retail Box contents
 *
 */
class LocationAuditTableRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collection: [],
            contentsLoaded: false,
            contentsLoading: false,
            showContents: false,
            showToggle: false,
        };
    }

    componentWillMount() {
        if (this.props.data) {
            const contentType = this.props.data.unit_type;
            let showToggle = (contentType === 'Repack' || contentType === 'Retail Box');
            this.setState({
                showToggle: showToggle
            });
        }
    }

    /**
     * Get Contents for a Repack or Retail Box
     *
     */
    fetchTransferContentContents() {
        const params = {
            filter: {
                sequence: this.props.data.barcode
            },
        };
        const resource = inventoryResources.LocationAuditCollection.GET_LIST(params);

        // Retrieve the data and store results
        import('../shared/functions')
            .then(functions => {
                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    const payload = result.data.payload;
                    if (payload) {
                        // Store the contents of the inventory collection model
                        let contents = [];
                        if (payload.inv_collection_model && payload.inv_collection_model.contents) {
                            contents = payload.inv_collection_model.contents;
                        }
                        this.setState({
                            collection: contents,
                            contentsLoading: false,
                            contentsLoaded: true
                        });
                    }
                }).catch((error) => {
                    if (error.response) {
                        // Server response outside 2xx
                        console.log(error.response.data);
                    } else if (error.request) {
                        // No response
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            });
    }

    /**
     * Create rows of Repack/Retail Box content
     * Pending: Editable Qty fields, connection to Redux form
     *
     * @return {*}
     */
    makeTransferContentsTable = () => {
        const list = this.state.collection;
        const contentType = this.props.data.unit_type;
        const styles = {
            rowHeight: {height: '38px'},
        };

        if (!list || list.length === 0 || !list.length) {
            return (
                <TableRow>
                    <TableRowColumn colSpan={4}>No Contents in this {contentType}</TableRowColumn>
                </TableRow>
            )
        }
        return (
            list.map((item, index) => (
                <TableRow key={`transfer-contents-row-${item.barcode.toString()}-${index}`} style={styles.rowHeight}>
                    <TableRowColumn style={styles.rowHeight}>
                        {item.barcode}
                    </TableRowColumn>
                    <TableRowColumn style={styles.rowHeight}>
                        {item.product_name}
                    </TableRowColumn>
                    <TableRowColumn style={styles.rowHeight}>
                        {item.unit_type}
                    </TableRowColumn>
                    <TableRowColumn style={styles.rowHeight}>
                        {item.qty} / {item.unit_qty}
                    </TableRowColumn>
                </TableRow>
            ))
        )
    };

    // Handle event to display/hide Repack / Retail Box contents
    handleToggleClick = () => {
        const toggleState = this.state.showContents;
        this.setState({
            contentsLoading: true,
            showContents: !toggleState,
        });
        if (!this.state.contentsLoading && !this.state.contentsLoaded) {
            this.fetchTransferContentContents();
        }
    };

    render() {
        const {
            barcode,
            qty,
            unit_type
        } = this.props.data;

        const styles = {
            bg: {backgroundColor: '#f6f6f6',},
            columnSmall: {paddingLeft: 10, paddingRight: 10},
            detailColumn: {
                backgroundColor: '#f6f6f6',
                borderBottom: '1px solid ' + FuseTheme.palette.borderColor,
            },
            detailRow: {height: 'auto', borderBottom: 'none'},
            detailRowHidden: {display: 'none'},
            rowHeight: {height: '38px'},
            icon: {height: '32px', padding: '4px', overflow: 'inherit'},
            iconColumn: {padding: '0 14px'},
        };

        let hasContents = (unit_type === 'Repack' || unit_type === 'Retail Box');

        return ([
            <TableRow key={`transfer-contents-row-${barcode.toString()}`} style={styles.rowHeight}>
                <TableRowColumn colSpan={2} style={styles.rowHeight}>
                    {barcode}
                </TableRowColumn>
                <TableRowColumn style={{...styles.rowHeight, ...styles.columnSmall}}>
                    {qty}
                </TableRowColumn>
                <TableRowColumn style={styles.rowHeight}>
                    {unit_type}
                </TableRowColumn>
                <TableRowColumn style={{...styles.rowHeight, ...styles.iconColumn}}>
                    {this.state.showToggle &&
                    <IconButton
                        style={styles.icon}
                        onClick={this.handleToggleClick}
                    >
                        {!this.state.showContents &&
                        <IconToggleOpen color={FuseTheme.palette.primary1Color}/>
                        }
                        {this.state.showContents &&
                        <IconToggleClose color={FuseTheme.palette.primary1Color}/>
                        }
                    </IconButton>
                    }
                </TableRowColumn>
            </TableRow>,
            <TableRow
                key={`transfer-contents-row-contents-${barcode.toString()}`}
                style={(hasContents) ? styles.detailRow : styles.detailRowHidden}
            >
                {hasContents && this.state.showContents &&
                <TableRowColumn colSpan={5} style={styles.detailColumn}>
                    {this.state.contentsLoaded &&
                    <Table selectable={false} multiSelectable={false} style={styles.bg}>
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                            <TableRow style={styles.rowHeight}>
                                <TableHeaderColumn style={styles.rowHeight}>Barcode</TableHeaderColumn>
                                <TableHeaderColumn style={styles.rowHeight}>Product</TableHeaderColumn>
                                <TableHeaderColumn style={styles.rowHeight}>Unit Type</TableHeaderColumn>
                                <TableHeaderColumn style={styles.rowHeight}>Qty / Unit Qty</TableHeaderColumn>
                            </TableRow>
                        </TableHeader>
                        <TableBody displayRowCheckbox={false}>
                            {[...this.makeTransferContentsTable()]}
                        </TableBody>
                    </Table>
                    }
                </TableRowColumn>
                }
            </TableRow>
        ])
    }
}

LocationAuditTableRow.propTypes = {
    data: PropTypes.object.isRequired,
};

LocationAuditTableRow.defaultProps = {
    style: {padding: 0},
};

export default LocationAuditTableRow;


// WEBPACK FOOTER //
// ./src/Fuse/components/LocationAuditTableRow.js